<div mat-dialog-title class="fx-layout-row fx-align--x-center">
  <h2>
    Take a Closer Look
  </h2>
  <div class="fx-flex-grow"></div>
  <button mat-icon-button mat-dialog-close tabindex="-1">
    <mat-icon svgIcon="x"> </mat-icon>
  </button>
</div>
<mat-dialog-content>
  <mat-spinner color="secondary" [hidden]="imageLoaded" class="center"></mat-spinner>
  <pinch-zoom backgroundColor="rgba(0,0,0,0)" [doubleTapScale]="2" disableZoomControl="never">
    <img loading="lazy" [src]="imageUrl" (load)="imageLoaded = true" alt="zoomed image"/>
  </pinch-zoom>
</mat-dialog-content>
